/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

"use client";

import { CosmosComponentContext, CosmosComponentContextProps } from "@cosmos/components";
import { EDSProvider } from "@eds-web/react";
import { LocationProvider } from "@epic-mw/app-context";
import { MotionConfig } from "framer-motion";
import { usePathname, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";

interface Props {
	children?: React.ReactNode;
	componentContext: CosmosComponentContextProps;
}

export const TemplateProviders = ({ children, componentContext }: Props): React.JSX.Element => {
	const [hash, setHash] = useState("");
	useEffect(() => {
		if (typeof window !== "undefined" && window?.location?.hash && hash !== window?.location?.hash) {
			setHash(window.location.hash);
		}
	}, [hash]);
	const pathname = usePathname();
	const searchParams = useSearchParams();
	const search = searchParams.toString();
	const searchStr = search && search.length ? `?${search}` : "";
	const urlStr = `${process.env.NEXT_PUBLIC_EPIC_SERVER_URL}${pathname}${searchStr}${hash}`;
	const location = new URL(urlStr);

	return (
		<EDSProvider dir={"ltr"} themeClass={""}>
			<LocationProvider location={location}>
				<CosmosComponentContext.Provider value={componentContext}>
					<MotionConfig reducedMotion="user">{children}</MotionConfig>
				</CosmosComponentContext.Provider>
			</LocationProvider>
		</EDSProvider>
	);
};
